export default __webpack_public_path__ + "static/media/orphanswords-ascent-02.4ab1648e.jpg";